export default __webpack_public_path__ + "static/media/full_trash_icon.b485a48f.png";